const SPENT_ON_CATEGORY = "Total Amount Spent(₪)";
const NUM_OF_EXPENSES = "Number of Expenses";
const GROUP_BY_YEAR = "year";
const GROUP_BY_MONTH = "month";
const GROUP_BY_CATEGORY = "category";

module.exports = {
  SPENT_ON_CATEGORY,
  NUM_OF_EXPENSES,
  GROUP_BY_CATEGORY,
  GROUP_BY_MONTH,
  GROUP_BY_YEAR,
};
